export const initAnchorLinkOffset = () => {
	document.addEventListener('DOMContentLoaded', () => {
		const header = document.querySelector('.js-header');
		const headerHeight = header ? header.offsetHeight : 0; // Default to 0 if header does not exist

		document.querySelectorAll('.c-editorial a[href^="#"], .richtext a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();

				const targetId = this.getAttribute('href').substring(1);
				const targetElement = document.getElementById(targetId);
				if (targetElement) {
					const targetPosition =
						targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth',
					});
				}
			});
		});
	});
};
